//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FilesGroup from '../../components/File/FilesGroup.js'
import FilesField from '../../components/File/FilesField.vue'

export default {
  components: {
    FilesField
  },
  props: {
    document: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      imagesFilesGroup: null
    }
  },
  created: function () {
    if (this.document.auditRemarksDocuments) {
      const document = this.document.auditRemarksDocuments
      const imagesId = document.filter((item) => {
        return this.isImage(item.contentType) && item.category !== 'files'
      })
      if (!document.imagesFilesGroup && imagesId !== undefined) {
        document.imagesFilesGroup = new FilesGroup({
          key: 'images',
          readonly: true
        })
        imagesId.forEach((item, index) => {
          document.imagesFilesGroup.pushFile({
            id: item.id,
            name: item.name + '_замечание по аудиту' + '-' + (index + 1) + '.' + item.contentType.split('/')[1]
          })
        })
      }
      this.imagesFilesGroup = document.imagesFilesGroup
    }
  },
  methods: {
    isImage: function (str) {
      return str != null && str.startsWith('image/')
    }
  }
}

